module.exports = __webpack_public_path__ + "static/media/Awake (East Africa).59c76c8b.jpg";